// UserSites.tsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from "../auth/AuthProvider";

interface Group {
  group_id: number;
  group_name: string;
}

interface Site {
  site_id: number;
  site_name: string;
  groups: Group[]; // groups 정보 추가
}

interface Area {
  area_id: number;
  area_name: string;
  sites: Site[];
}

const SOCKET_URL = 'https://rek-hybrid.co.kr';

const UserSites: React.FC = () => {
    const { user } = useAuth();
    const [areas, setAreas] = useState<Area[]>([]);
    const [selectedAreaId, setSelectedAreaId] = useState<number | null>(null);   
    const [sites, setSites] = useState<Site[]>([]);
    const [selectedSiteId, setSelectedSiteId] = useState<number | null>(null);
    const [selectedGroupId, setSelectedGroupId] = useState<number | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const [deviceInfo, setDeviceInfo] = useState<any>(null);

    // 페이지 접속 시 로그인한 user.id로 사이트 + 그룹 목록 조회
    useEffect(() => {
    if (!user) return;

    const fetchSites = async () => {
        try {
            // setLoading(true);
            setError('');
            // const response = await axios.get<Site[]>(`${SOCKET_URL}/user/${user.id}/sites`);
            // setSites(response.data);
            const response = await axios.get<Area[]>(`${SOCKET_URL}/api/user/${user.id}/areas`);
            setAreas(response.data);

            if (response.data.length > 0) {
                //setSelectedSiteId(response.data[0].site_id);
                //setSelectedGroupId(response.data[0].groups?.[0]?.group_id ?? null); // 기본 그룹 선택
            }

            console.log('[DEBUG] React: API 응답', response.data);
            } catch (err) {
            setError('사이트 정보를 불러오는데 실패했습니다.');
            console.error('[DEBUG] React: API 호출 에러', err);
            } finally {
            // setLoading(false);
            }
        };

        fetchSites();
    }, [user]);

    // 선택한 사이트의 그룹 목록 가져오기
    const selectedArea = areas.find(a => a.area_id === selectedAreaId);
    const selectedSite = selectedArea?.sites.find(s => s.site_id === selectedSiteId);
  //const selectedSite = sites.find(s => s.site_id === selectedSiteId);

  const handleConfirm = () => {
    if (selectedSiteId !== null && selectedGroupId !== null) {
      alert(`선택한 Site ID: ${selectedSiteId}, Group ID: ${selectedGroupId}`);
    } else {
      alert('사이트와 그룹을 선택하세요.');
    }
  };


  const fetchDeviceInfo = async () => {
    const deviceId = 1;
    try {
      const response = await axios.get(`${SOCKET_URL}/api/device/info`, {
        params: { selectedSiteId, selectedGroupId, deviceId },
      });
      //const response = await axios.post(`${SOCKET_URL}/device/info`, { selectedSiteId, selectedGroupId, deviceId });
      if(response.data === null || response.data === '')
      {
        console.log('[DEBUG] React: 조회 값 없음');
        setDeviceInfo(0);
      }
      else
      {
        //console.log('[DEBUG] React: 조회 응답', response.data);
        setDeviceInfo(response.data);
      }
    } catch (error) {
      console.error('[DEBUG] React: API 호출 실패', error);
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '500px', margin: '0 auto' }}>
      <h1>사용자 사이트 설정</h1>

      {loading && <p>로딩 중...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}

      {/* {!loading && !error && sites.length > 0 && ( */}
        <div style={{ marginTop: '10px' }}>

            {/* Area 선택 */}
            <div className="flex items-center justify-between">
                <label className="w-24 text-sm font-medium">Area 선택</label>
                <select
                    className="flex-1 p-2 border rounded-lg"
                    value={selectedAreaId ?? ''}
                    onChange={(e) => {
                        const areaId = e.target.value ? Number(e.target.value) : null;
                        setSelectedAreaId(areaId);
                        setSelectedSiteId(null);
                        setSelectedGroupId(null);
                    }}
                >
                    <option value="">지역 선택</option>
                    {areas.map(area => (
                    <option key={area.area_id} value={area.area_id}>
                        {area.area_name}
                    </option>
                    ))}
                </select>
            </div>

            <br />

            {/* 사이트 선택 */}
            <div style={{ marginBottom: '10px' }}>
                <label style={{ marginRight: '10px' }}>사이트 선택: </label>
                <select
                className="flex-1 p-2 border rounded-lg"
                value={selectedSiteId ?? ''}
                onChange={(e) => {
                    //const siteId = Number(e.target.value);
                    const siteId = e.target.value ? Number(e.target.value) : null;
                    setSelectedSiteId(siteId);
                    setSelectedGroupId(null);
                    // setSelectedGroupId(sites.find(s => s.site_id === siteId)?.groups?.[0]?.group_id ?? null);
                }}
                style={{ padding: '5px', marginRight: '10px' }}
                >
                <option value="">사이트 선택</option>
                {selectedArea?.sites.map(site => (
                    <option key={site.site_id} value={site.site_id}>
                    {site.site_name}
                    </option>
                ))}
                </select>
            </div>

            <br />

            {/* 그룹 선택 */}
            <div style={{ marginBottom: '10px' }}>
                <label style={{ marginRight: '10px' }}>그룹 선택: </label>
                <select
                className="flex-1 p-2 border rounded-lg"
                value={selectedGroupId ?? ''}
                onChange={(e) => setSelectedGroupId(Number(e.target.value))}
                style={{ padding: '5px', marginRight: '10px' }}
                >
                <option value="">그룹 선택</option>
                {selectedSite?.groups.map(group => (
                    <option key={group.group_id} value={group.group_id}>
                    {group.group_name}
                    </option>
                ))}
                </select>
            </div>

          <button onClick={handleConfirm} style={{ padding: '5px 10px' }}>
            설정
          </button>

            <div>
            <button onClick={fetchDeviceInfo}>조회</button>
            {deviceInfo && (
                <div style={{ marginTop: '10px' }}>
                <p>LED 상태: {deviceInfo.ledStatus}</p>
                <p>배터리 전압: {deviceInfo.batteryVolt}</p>
                <p>온도: {deviceInfo.temperature}</p>
                <p>습도: {deviceInfo.humidity}</p>
                <p>최신 시간: {deviceInfo.created_at}</p>
                </div>
            )}

            </div>

        </div>
      {/* )} */}

      {/* {!loading && !error && sites.length === 0 && <p>접근 가능한 사이트가 없습니다.</p>} */}
    </div>
  );
};

export default UserSites;
